import { Grid } from '@mui/material';
import { SimpleTable } from '@tassat/ag-grid';
import { SubmitButton } from '@tassat/button';
import React from 'react';
import ReactGA from 'react-ga4';
import { Link } from 'react-router-dom';

import { generateRowDataForAccountBalances } from 'Lib/accountBalancesHelper';
import { useAppSelector } from 'Reducers/store/hooks';
import { getClientAccountPositionStats } from 'Selectors/accountPositions';
import { getAllAssetsArray } from 'Selectors/assets';

import { columnDefs } from './accountBalancesGridOptions';
import { muiStyles } from './styles';

import type { AccountBalancesProps } from './';

const AccountBalances: React.FC<AccountBalancesProps> = ({ setAssetListOverlayOpen }) => {
    const classes = muiStyles();
    const accountBalancesStats = useAppSelector((state) => getClientAccountPositionStats(state, state?.user?.UserId || '', '', false, false));
    const assets = useAppSelector((state) => getAllAssetsArray(state));
    const accountBalancesData = generateRowDataForAccountBalances(accountBalancesStats, assets);

    const TotalRow = () => (
        <Grid
            className={classes.totalBalanceContainer}
            container
        >
            <Grid
                className={classes.totalBalanceTitle}
                item
            >Total Balances
            </Grid>
            <Grid item>{accountBalancesData[0].totalBalance}</Grid>
        </Grid>
    );

    return (
        <Grid container>
            <SimpleTable
                AboveHeaderComponent={TotalRow}
                columnDefs={columnDefs}
                defaultColDef={{
                    resizable: true,
                    sortable: true
                }}
                minHeight={120}
                overlayNoRowsTemplate='No linked accounts'
                rowData={accountBalancesData[0].list}
                title='LYNQ Account Balances'
            />
            <Grid
                className={classes.infoText}
                item
                xs={12}
            >
                Click{' '}
                <Link
                    className={classes.anchorText}
                    to='/support'
                >
                    here{' '}
                </Link>
                to access fund documents.
            </Grid>
            {accountBalancesData[0].list.length !== 0 && (
                <Grid
                    className={classes.seeDetailsButtonContainer}
                    container
                    item
                    justifyContent='center'
                    xs={12}
                >
                    <SubmitButton
                        className={classes.seeDetailsButton}
                        onClick={() => {
                            ReactGA.event('click', {
                                event_category: 'engagement',
                                event_label: 'account_balances_see_details'
                            });
                            if (setAssetListOverlayOpen) {
                                setAssetListOverlayOpen(true);
                            }
                        }}
                        text='See Details'
                        type='submit'
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default AccountBalances;